.header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.title {
    margin-right: 20px;
    align-self: flex-start;
}

.dataSelectionFiltersContainer {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.userFilter {
    width: 350px;
}

.dateFilter {
    width: 270px;
}

.red {
    color: var(--hps-red);
}

.white {
    color: var(--hps-white);
}

.yellow {
    color: var(--hps-yellow);
}